import React, { useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { useCompany } from '@/context/CompanyContext';
import { useUserSettings } from '@/hooks/useUserSettings';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import { usePlanAccess } from '@/hooks/usePlanAccess';

// Composant pour protéger les routes
export const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, isLoading } = useAuth();
  
  if (isLoading) {
    return <LoadingSpinner message="Vérification de l'authentification..." />;
  }
  
  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  // Rediriger vers l'onboarding si nécessaire
  if (user.needsOnboarding && window.location.pathname !== '/onboarding') {
    return <Navigate to="/onboarding" replace />;
  }

  return <>{children}</>;
};

// Composant pour rediriger les utilisateurs connectés
export const PublicRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, isLoading } = useAuth();
  const { userRole } = useCompany();
  const { settings } = useUserSettings();
  const { plan, loading: planLoading } = usePlanAccess();
  
  if (isLoading || planLoading) {
    return <LoadingSpinner message="Vérification de l'authentification..." />;
  }
  
  if (user) {
    // Rediriger selon le plan de l'utilisateur
    if (plan === 'stats') {
      return <Navigate to="/statistics" replace />;
    }
    return <Navigate to="/" replace />;
  }
  
  return <>{children}</>;
};